import { Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NotificationTextMessage } from '@app/core/Enum';
import { CommonService } from '@app/core/Services';
import { CreateAdditionalNotesAndPolicy } from '@app/core/Store';
import { Store } from '@ngxs/store';
import { NgxSpinnerService } from 'ngx-spinner';


@Component({
  selector: 'app-add-new-note-popup',
  templateUrl: './add-new-note-popup.component.html',
  styleUrls: ['./add-new-note-popup.component.scss']
})
export class AddNewNotePopupComponent implements OnInit {

  form : FormGroup;
  noteData:any;
  renderer: Renderer2;
  commonNotificationText = NotificationTextMessage;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<AddNewNotePopupComponent>,
    public commonService: CommonService,private spinner: NgxSpinnerService,private store: Store
  ) { }

  ngOnInit(): void {
    this.setForm();
    if(this.data.row){
      this.form.patchValue({
        'title':this.data?.row?.title,
        'noteContents':this.data?.row?.content
      
      })
    }
  }

  onCloseClick() : void {
    this.dialogRef.close(false);
  }

  setForm(): void {
    this.form = new FormGroup({
      title: new FormControl('', [
        Validators.required,
      ]),
      noteContents: new FormControl('', [
        Validators.required
      ]),
    });
  }

  onSave(): void {
      if (this.form.invalid) {
        this.commonService.addValidation(
          this.form,
          this.renderer
        );
      } else {
        if (this.dataSubmit()) {
          this.store
            .dispatch(new CreateAdditionalNotesAndPolicy(this.noteData,(this.data?.type)?(this.data?.type):'Notes'))
            .subscribe(
              (res) => {
           
                if (res.annualReport?.isSuccess) {
                  
                  this.commonService.onSucess(
                    NotificationTextMessage.successMessage
                  );
                  this.dialogRef.close(true);
                } else {
                  this.commonService.onFailure(
                    NotificationTextMessage.errorMessage
                  );
                }
              },
              (err) => {
                this.commonService.onFailure(err.error.Message);
              }
            );
        }
      }
    }

     dataSubmit(): boolean {
 
        this.spinner.show();
        try {
         
          this.noteData = {
            id: (this.data?.row?.id)?this.data?.row?.id:this.commonService.defaultGuidValue,
            companyId: this.commonService.defaultGuidValue,
            title: this.form.controls.title.value,
            content: this.form.controls.noteContents.value,
            isActive: true,
            createdBy:this.commonService.defaultGuidValue,
            updatedBy: this.commonService.defaultGuidValue,
            updatedOn: new Date()
          };
        } catch (error) {
          this.spinner.hide();
          this.commonService.onFailure(NotificationTextMessage.errorMessage);
          return false;
        }
        return true;
      }

      onReset():void{
        this.form.reset();
      }
  
}
